export enum InterviewPracticeStepCode {
    CHROME_DOWNLOAD = 'CHROME_DOWNLOAD',
    PERMISSION = 'PERMISSION',
    INTRO = 'INTRO',

    TEST_START = 'TEST_START',
    TEST_PROGRESS = 'TEST_PROGRESS',
    TEST_END = 'TEST_END',

    GUIDE_STEP1 = 'GUIDE_STEP1',
    GUIDE_STEP2 = 'GUIDE_STEP2',

    PRACTICE_GUIDE = 'PRACTICE_GUIDE',
    PRACTICE_THINK = 'PRACTICE_THINK',
    PRACTICE_SUBMITTED_GUIDE = 'PRACTICE_SUBMITTED_GUIDE',
    PRACTICE_RECORD = 'PRACTICE_RECORD',

    FINISH_GUIDE = 'FINISH_GUIDE',
    FINISH_RESULT = 'FINISH_RESULT'
}
